<table class="table table-striped">
    <tr><td>Date Created</td><td>{{subTopic.datecreated}}</td></tr>
    <tr><td>Last Updated</td><td>{{subTopic.lastupdated}}</td></tr>
    <tr><td>Name</td><td>{{subTopic.name}}</td></tr>
    <tr><td>Description</td><td>{{subTopic.description}}</td></tr>
    <tr><td>Code</td><td>{{subTopic.subtopiccode}}</td></tr>
    <tr><td>Is Open</td><td>{{subTopic.is_open}}</td></tr>
</table>
<form  [formGroup]="searchTemplateForm" *ngIf="server_subtopic_id!=0" >
  <div class="row">
            <div class="col-sm-4" > Search Template</div>
            <div class="col-sm-4" >
                <input   formControlName="searchInput" class="form-control"/>
            </div>
     </div>
</form>
<h6 class="alert alert-info text-center"> Task Templates</h6>
                <table *ngIf="subTopic['taskTemplates']"  class='table table-sm table-striped'>
                  <thead>
                   <tr>
                     <th>Name</th>
                     <th>Enabled</th>
                     <th>Answer</th>
                     <th>Mode</th>
                     <th>Remove</th>

                    </tr>
                  </thead>

                  <tbody>
                   <tr *ngFor="let taskTemplate of subTopic['taskTemplates'];">
                     <td>
                         <a [routerLink]="['/task/template/show',taskTemplate.id]">{{taskTemplate.name}}</a>
                     </td>
                     <td><span>{{taskTemplate.enabled==1?'Yes':'No'}}</span></td>
                     <td>{{taskTemplate.answerTemplateName}}</td>
                     <td>STANDARD</td>
                     <td><a  (click)="onRemoveTemplate(taskTemplate.id)" class="delete btn btn-danger">X</a></td>
                   </tr>
                   </tbody>
                   </table>
<ul>
    <li *ngFor="let topicInfo of subTopicTemplateList;" style="list-style: none;">

    <ul>
      <li>{{topicInfo.text}}</li>
      <ul>
        <li *ngFor="let template of topicInfo.templates" style="list-style: none;">
          <button (click)="addTemplate(template.id)" class="mt-1"> AddTemplate</button> {{template.text}}
        </li>
      </ul>

    </ul>
   </li>
</ul>
<div class="text-center">
  <a [routerLink]="['/admin/subtopic/show',subTopic.server_subtopic_id]"> Cancel</a>
</div>


